module.exports = __webpack_public_path__ + "static/media/18ECA50.6184128f.jpg";